import React from 'react';
import Crash from '../../components/Games/Crash';

export default function CrashGamePage() {
  return <Crash />;
}
